import React, { useState, useEffect, useRef } from 'react';
import './css/notification.css';
import actions from '../../../Redux/Action';
import { useDispatch } from 'react-redux';
const Notification = (props) => {
  const [isMobile, setIsMobile] = useState(false);
  const [showPopup, setShowPopup] = useState(false);
  const preventClickOpen = useRef(false);
  const [couponData, setCouponData] = useState([]);
  const dispatch = useDispatch()
  let { userData, handleScroll, isLoggedIn, handleLogging, handleLoggin, token,AuthToken, NotificationBanner } = props
  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 768);
    const menuAnchors = document.querySelectorAll('.gnb__depth1-menu a');
    menuAnchors.forEach(anchor => {
      anchor.addEventListener('mouseenter', () => setShowPopup(false));
    });
    window.addEventListener('resize', handleResize);
    handleResize();
    document.addEventListener('click', handleClickOutside);
    return () => {
      document.removeEventListener('click', handleClickOutside);
      menuAnchors.forEach(anchor => {
        anchor.removeEventListener('mouseenter', () => setShowPopup(false));
      });
    };
  }, []);
  useEffect(() => {
    NotificationBanner && NotificationBanner.length > 0 && token && dispatch(actions.CommonActions.CouponNotification(token,AuthToken, (res) => {
      if (res.Success && res.Entity && res.Entity.length) {
        let NotRedeemed = NotificationBanner.find(item => item.Type === "NotificationNotRedeemed") || {}
        let Redeemed = NotificationBanner.find(item => item.Type === "NotificationRedeemed") || {}

        let coupons = res.Entity.map(item => {
          if (item.StatusID == 1 && Object.keys(NotRedeemed).length) {
            return { ...item, ...NotRedeemed, redeemed: false }
          }
          if (item.StatusID != 1 && Object.keys(Redeemed).length) {
            return { ...item, ...Redeemed, redeemed: true }
          }
        }).filter(Boolean)
        setCouponData(coupons)
      }
    }))
  }, [token, NotificationBanner])

  const handleClickOutside = (e) => {
    if (!e.target.closest('.notification-wrapper')) {
      setShowPopup(false);
    }
  }
  const handleBack = () => {
    setShowPopup(false);
    preventClickOpen.current = true;
  };
  // const handleMouseEnter = () => {
  //   if (!isMobile) setShowPopup(true);
  // };
  // const handleMouseLeave = () => {
  //   if (!isMobile) setShowPopup(false);
  // };
  const handleNotificationToggle = (e) => {
    e.preventDefault();
    setShowPopup((prev) => !prev);
    let readCheck = couponData.length > 0 && couponData.findIndex(item =>
      !item.ReadStatus) != -1 ? true : false
    readCheck && dispatch(actions.CommonActions.UpdateCouponReadStatus(token, (res) => {
      if (res.Success) {
        let coupons = couponData && couponData.length && couponData.map(item => {
          return { ...item, ReadStatus: true }
        })
        setCouponData(coupons)
      }
    }))
  }
  
  return (
    <div className="notification-wrapper" >
      <a className="gnb__search-btn gnb__search-btn-js notification-btn" href=""
        onClick={handleNotificationToggle} // toggle on click
        // onMouseEnter={handleMouseEnter}
        // onMouseLeave={handleMouseLeave}
        aria-haspopup="true"
        role="button" an-tr="nv00_gnb--image-search" an-ca="navigation" an-ac="gnb"
        an-la="search">
        <span className="hidden">Notification</span>
        <span className={couponData.length > 0 && couponData.findIndex(item => !
          item.ReadStatus) != -1 ? 'icon-image-wrapper' : ''}>
          <img className="icon " src="./img/notification/bell-icon.svg" width="24" focusable="false" />
        </span>
      </a>
      {showPopup && (
        <div className={`popup-container ${isMobile ? 'mobile' : 'desktop'}`}>
          <div className="popup-header">
            {isMobile && (
              <button className="back-btn" onClick={handleBack}>
                <img src="./img/notification/back-button.svg" focusable="false" />
              </button>
            )}
            <h4>Notifications ({couponData.length || 0})</h4>
          </div>
          <div className="popup-content">
            {couponData.length > 0 ?
              (couponData.map((item, i) => (
                <div key={i}>
                  <div className="notif-item">
                    {/* <p className="time text-right m-0">
                      <img src="./img/notification/grey-tick.svg" width="15" focusable="false" />
                      {item.time}</p> */}
                    <div className="coupon-item">
                      {(props.isMobile && item.BannerMobileImage_Byte) ?
                        <img
                          className="notif-image"
                          src={`data:image/${item.MobileExtention.replace(/^\./, '')};base64,${item.BannerMobileImage_Byte}`}
                          alt={'Offer banner'}
                        />
                        : !props.isMobile && item.BannerWebImage_Byte ?
                          <img
                            className="notif-image"
                            src={`data:image/${item.WebExtention.replace(/^\./, '')};base64,${item.BannerWebImage_Byte}`}
                            alt={'Offer banner'}
                          />
                          : <img className="notif-image" src="./img/notification/gift_icon.svg" alt={'Offer banner'} />
                      }
                      <div className="coupon-text">
                        <p className="title">{item.Title}</p>
                        <p className="desc">{item.LongDescription}</p>
                        <div className='status-coupon'>
                          <span className='sts-txt'>
                            <span className='coupon-label'>Coupon Status:</span>
                            <span className='coupon-code'>{item.CouponNo}</span>
                          </span>
                          <div className={`status-badge ${item.StatusID == 1 ? 'unredeemed' : item.StatusID == 2 ? 'redeemed' : 'expired'}`}>
                            <span className="status-icon">
                              {item.StatusID == 1 ? (
                                <img
                                  src="./img/notification/orange-time.svg"
                                  alt="Not Redeemed"
                                />
                              ) : item.StatusID == 2 ? (
                                <img
                                  src="./img/notification/green-tick.svg"
                                  alt="Redeemed"
                                />
                              ) : (
                                <img
                                  src="./img/notification/expired.svg"
                                  alt="Expired"
                                />
                              )}
                            </span>
                            <span>
                              {item.StatusID == 1 ? 'Not Redeemed' : item.StatusID == 2 ? ' Redeemed' : 'Expired'}
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                    {item.ShortDescription && <a href={item.BannerURL} target="_blank" className="next cta cta--contained cta--black cta--outlined cta--icon" onClick={e => handleLogging('', { ChildMenuRedirectURL: item.BannerURL, ChildMenuName: item.ShortDescription, ChildMenuTitle: item.StatusID == 1 ? 'Not Redeemed Coupon' : item.StatusID == 2 ? ' Redeemed Coupon' : 'Expired Coupon', ChildCatogoryCode: item.CouponNo }, 1, 'Notification Coupon')}>{item.ShortDescription}</a>}
                  </div>
                  {/* Show separator except after last item */}
                  {i < couponData.length - 1 && <hr />}
                </div>
              ))) :
              (<div className="no-notif-item">
                <img className="icon " src="./img/notification/bell-icon.svg" width="24" focusable="false" />
                <p className="no-item">There is no notification right now.</p>
              </div>)}
          </div>
        </div>
      )}
    </div>
  );
};
export default Notification